import { apiLabs } from '../../api'

const OrderApproved = async (body) => {
	const res = await apiLabs.post('recover_sale/approved', body)
	return res
}

export default OrderApproved